// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3dA93","alertIcon":"ConfirmModal_alertIcon__1eYV1"};